import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../css/OrderConfirmation.css';

function OrderConfirmationPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const { message, orderId, amount, items } = location.state || {};

    if (!orderId) {
        navigate('/'); // Redirect if accessed directly
        return null;
    }

    return (
        <div className="order-confirmation">
            <h1>{message}</h1>
            <p><strong>Order Number:</strong> {orderId}</p>
            <p><strong>Amount Paid:</strong> Rs.{amount}</p>
            <h3>Order Details:</h3>
            <ul>
                {items && items.map((item, idx) => (
                    <li key={idx}>
                        {item.title} - {item.quantity} x Rs.{item.price}
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default OrderConfirmationPage;
